export function extractMachineIdent(payload) {
  if (!payload || typeof payload !== "object") return "";
  const value =
    payload.id_maquina ||
    payload.machineId ||
    payload.nome_maquina ||
    payload.improvisedId ||
    payload.valor_principal;
  return value != null ? String(value).trim() : "";
}

export function extractAssumeTimestamp(row) {
  const payload = row.payloadData || {};
  const raw =
    payload.timestamp_utc ||
    payload.timestamp ||
    row.received_at;
  return raw || null;
}

export function extractHourMeter(payload) {
  if (!payload || typeof payload !== "object") return null;
  const value =
    payload.horimetro_maquina != null && payload.horimetro_maquina !== ""
      ? payload.horimetro_maquina
      : payload.horimetro;
  if (value == null || value === "") return null;
  return value;
}

export function extractPanelHectares(payload) {
  if (!payload || typeof payload !== "object") return null;
  const value =
    payload.hectares_painel_inicial != null &&
    payload.hectares_painel_inicial !== ""
      ? payload.hectares_painel_inicial
      : payload.hectares_painel;
  if (value == null || value === "") return null;
  return value;
}

export function buildMachineOperationMap(machines) {
  const map = {};
  (machines || []).forEach((machine) => {
    if (!machine || !machine.ident) return;
    map[String(machine.ident).trim()] = {
      equipmentId: machine.id,
      monitoringOperationId: machine.monitoringOperationId || null,
    };
  });
  return map;
}

export function groupAssumeEventsByMachine(rows) {
  const groups = new Map();

  (rows || []).forEach((row) => {
    const machineIdent = extractMachineIdent(row.payloadData);
    if (!machineIdent) return;

    const key = machineIdent;
    if (!groups.has(key)) {
      groups.set(key, {
        machineIdent,
        events: [],
      });
    }
    groups.get(key).events.push(row);
  });

  return Array.from(groups.values())
    .map((group) => ({
      ...group,
      events: group.events.sort(
        (a, b) =>
          new Date(extractAssumeTimestamp(b)).getTime() -
          new Date(extractAssumeTimestamp(a)).getTime()
      ),
      lastAssumedAt: extractAssumeTimestamp(group.events[0]),
      count: group.events.length,
    }))
    .sort(
      (a, b) =>
        new Date(b.lastAssumedAt || 0).getTime() -
        new Date(a.lastAssumedAt || 0).getTime()
    );
}
